import { PlusIcon } from "@xola/icons";
import { Badge } from "@xola/ui-kit";
import { startCase } from "lodash";
import React from "react";
import { Audit, LineItem, LineItemType, Purchase, PurchaseItem, PurchaseItemObject } from "types";
import { TimelineItem } from "../TimelineItem";
import { MerchandiseCreatedTimelineItem } from "./MerchandiseCreatedTimelineItem";
import PaymentTimelineItemContent from "./PaymentTimelineItemContent";
import { isMerchandiseItem } from "@/models/PurchaseItem";

interface CreatedTimelineItemProps {
    purchase: Purchase;
    item: PurchaseItem;
    audits?: Audit[];
    showDate?: boolean;
}

export const CreatedTimelineItem = ({ purchase, item, audits = [], showDate = false }: CreatedTimelineItemProps) => {
    const audit = {
        createdAt: purchase.createdAt,
        createdBy: purchase.createdBy,
    };

    const firstItem =
        purchase.lineItems.length > 0 ? purchase.lineItems[0] : { amount: item.amount, payment: { method: undefined } };
    const method = firstItem?.payment?.method;

    const lineItemCreatedBy = (firstItem as LineItem)?.createdBy?.id ?? null;
    const purchaseCreatedBy = purchase?.createdBy?.id ?? null;
    const shouldHidePayment = lineItemCreatedBy && purchaseCreatedBy && lineItemCreatedBy !== purchaseCreatedBy;

    /**
     * we can show payment done at creation only if lineItem.createdBy is same as purchase createdBy.
     * Incase traveler makes a booking in checkout and seller creates a payment later, we should not show payment details in this tile.
     */
    const shouldShowPayment = (firstItem as LineItem).type === LineItemType.PAYMENT && !shouldHidePayment;

    return (
        <TimelineItem
            title="Created"
            audit={audit}
            icon={<PlusIcon />}
            color="primary"
            showDate={showDate}
            purchase={purchase}
        >
            <div data-testid="created-timeline-item">
                {isMerchandiseItem(item) && <MerchandiseCreatedTimelineItem item={item} audits={audits} />}

                <div className="mt-2">{startCase(item?.source ?? "Unknown Source")}</div>
                {item?.object === PurchaseItemObject.GIFT && item?.name !== "Choose an amount" ? (
                    <Badge color="secondary" className="ml-1 mb-1">
                        {item.name}
                    </Badge>
                ) : null}
                {shouldShowPayment && (
                    <>
                        <br />
                        <PaymentTimelineItemContent amount={firstItem.amount * -1} method={method} />
                    </>
                )}
            </div>
        </TimelineItem>
    );
};
